import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { CssProps } from '../interfaces/generalContentProps';

export const GeneralContentStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.up('sm')]: {
        maxWidth: '592px', // 92.5%
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '608px', // 79.1%
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: '864px', // 84.3%
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: '1140px', // 83.4%
      },
    },
    imageBlock: {
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
    },
    videoContainer: {
      position: 'static',
      left: '50%',
      top: '20%',
      zIndex: 2,
      maxWidth: '350px',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '-40px',
    },
    imageContainer: {
      position: 'relative',
      paddingBottom: '25.25%',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '450px',
      marginTop: '-40px',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    startTaskVideoScroll: {
      maxHeight: 'calc(100vh - 430px)',
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 570px)',
      },
    },
    paperFrank: {
      marginBottom: '0',
      [theme.breakpoints.up('lg')]: {
        paddingBottom: '2rem',
      },
    },
    containerJimiFrank: {
      [theme.breakpoints.up('lg')]: {
        padding: '3rem 4.5rem',
      },
      [theme.breakpoints.up('md')]: {
        padding: '3rem 4.5rem;',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '2.5rem 0rem',
      },
      padding: '2rem 1.5rem',
      width: '100%',
    },
    paperCorrin: (props: CssProps) => ({
      [theme.breakpoints.up('md')]: {
        padding: '3rem 4.5rem',
        margin: '5rem 0',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '3rem',
        margin: '2.5rem 0',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '1.5rem',
        marginTop: '2rem',
        marginBottom: props.isICPEnabledCorrin ? '4rem' : '2rem',
      },
    }),
    withoutBannerSpacing: {
      [theme.breakpoints.up('md')]: {
        padding: '5rem 4.5rem 3rem 4.5rem',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        padding: '2.5rem 2.5rem',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '2rem 1.5rem',
      },
    },
    gridButton: {
      [theme.breakpoints.up('md')]: {
        paddingTop: '2rem',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        paddingTop: '1.5rem',
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: '1rem',
        paddingBottom: (props: CssProps): string => {
          let paddingBottom = '0.5rem';

          if (props.isICPEnabled) {
            paddingBottom = '2rem';
          }

          if (props.isICPEnabled && props.isLanguageSelectionFormOpen) {
            paddingBottom = '4rem';
          }

          return paddingBottom;
        },
      },
    },
    minGridTransitionHeight: {
      minHeight: 'calc(100vh - 40px - 0px)',
      '& .titleHeading': {
        fontSize: 24,
        fontWeight: '400',
      },
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 50px - 0px)',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 50px - 97px)',
      },
    },
    minGridHeight: {
      minHeight: 'calc(100vh - 40px - 165px)',
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 50px - 165px)',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 50px - 97px)',
      },
    },
    minCardHeight: {
      minHeight: 'calc(100vh - 140px - 165px)',
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 190px - 165px)',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 250px - 97px)',
      },
    },
    cardBottom: {
      marginBottom: '0',
      [theme.breakpoints.up('lg')]: {
        marginBottom: '5rem',
      },
    },
    bgImageJimi: (props: CssProps) => ({
      background: props.contentBgColor,
      [theme.breakpoints.up('lg')]: {
        background: `url('${props.backgroundImage}') no-repeat`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 0px',
        backgroundRepeat: 'no-repeat',
      },
    }),
    bgImageCorrin: (props: CssProps) => ({
      background: `url('${props.backgroundImage}') no-repeat fixed`,
      backgroundSize: 'cover',
      backgroundPosition: '50% 40px',
      [theme.breakpoints.up('md')]: {
        backgroundPosition: '50% 50px',
      },
    }),
    bgColorContainer: (props: CssProps) => ({
      backgroundColor: props.backgroundColor,
    }),
    bgColorContainerJimi: (props: CssProps) => ({
      backgroundColor: props.contentBgColor,
      [theme.breakpoints.up('lg')]: {
        backgroundColor: props.backgroundColor,
      },
    }),
    bgColorCard: (props: CssProps) => ({
      backgroundColor: props.contentBgColor,
    }),
    floatingCard: (props: CssProps) => ({
      marginTop: '0px',
      [theme.breakpoints.up('lg')]: {
        marginTop: props.marginTop,
        position: 'relative',
        zIndex: 1,
      },
    }),
    languageSelectionOverlay: {
      position: 'relative',
    },
    languageSelectionModal: {
      position: 'absolute',
      left: '50%',
      width: '20rem',
      marginLeft: '-10rem',
      transform: 'translateY(-85%)',
      [theme.breakpoints.down('xs')]: {
        width: '18rem',
        marginLeft: '-9rem',
      },
    },
  }),
);
